module.exports = __webpack_public_path__ + "img/s6.7bf69d86.jpg";